<template>
  <div class="download-page">
    <HeadNav selectedLanguage="en" page="download" />
    <Breadcrumbs :items="[{ name: 'Download' }]" />
    
    <!-- Header Section -->
    <section class="hero-section">
      <div class="container">
        <h1>GBWhatsApp APK Information for Android</h1>
        <p>This page is kept for version notes, compatibility details, and safety guidance only. Direct APK distribution is currently unavailable on this site.</p>
        <p>Visit the <a href="/help-center/"><strong>GB WhatsApp Help Center</strong></a> for setup guidance, troubleshooting tips, and privacy recommendations.</p>
      </div>
    </section>

    <!-- App Details Section -->
    <section class="app-details-section">
      <div class="container">
        <h2>GB WhatsApp App Details</h2>
        <div class="details-table">
          <table>
            <tr>
              <td><strong>Feature</strong></td>
              <td><strong>Details</strong></td>
            </tr>
            <tr>
              <td><strong>App Name</strong></td>
              <td><strong>GB WhatsApp</strong></td>
            </tr>
            <tr>
              <td><strong>Version</strong></td>
              <td><strong>v18.80</strong></td>
            </tr>
            <tr>
              <td><strong>Size</strong></td>
              <td><strong>62.25 MB</strong></td>
            </tr>
            <tr>
              <td><strong>Compatibility</strong></td>
              <td><strong>Android 10 or newer</strong></td>
            </tr>
            <tr>
              <td><strong>Key Features</strong></td>
              <td><strong>Anti-ban, custom themes, privacy options, large file sharing</strong></td>
            </tr>
            <tr>
              <td><strong>Last Updated</strong></td>
              <td><strong>2 Days Ago</strong></td>
            </tr>
            <tr>
              <td><strong>License</strong></td>
              <td><strong>Free</strong></td>
            </tr>
          </table>
        </div>
      </div>
    </section>

    <!-- Download Guide Section -->
    <section class="download-guide-section">
      <div class="container">
        <h2>GB WhatsApp APK Safety Notes</h2>
        <p>Review these checks before installing any third-party Android package from a source you trust:</p>
        
        <div class="guide-steps">
          <div class="step">
            <h3>Check the Source</h3>
            <p>Only use sources you can verify and avoid pages that force redirects or bundle unrelated installers.</p>
          </div>
          
          <div class="step">
            <h3>Review Permissions</h3>
            <p>Look at requested Android permissions before installation and avoid granting access that does not match your use case.</p>
          </div>
          
          <div class="step">
            <h3>Back Up Chats</h3>
            <p>Create a fresh local chat backup before updating or replacing any messaging app.</p>
          </div>
          
          <div class="step">
            <h3>Scan the File</h3>
            <p>Use trusted mobile security tools to scan files before opening them.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Installation Guide Section -->
    <section class="installation-guide-section">
      <div class="container">
        <h2>Guide to Install GB WhatsApp</h2>
        <p>Installing GB WhatsApp is simple:</p>
        
        <div class="guide-steps">
          <div class="step">
            <h3>Enable Unknown Sources</h3>
            <p>Go to <strong>Settings</strong> > <strong>Security</strong> > Enable "<strong>Install from Unknown Sources</strong>."</p>
          </div>
          
          <div class="step">
            <h3>Open the APK File</h3>
            <p>Locate the downloaded GB WhatsApp APK in your file manager.</p>
          </div>
          
          <div class="step">
            <h3>Install the App</h3>
            <p>Tap the APK file and select "<strong>Install</strong>." Wait for the process to finish.</p>
          </div>
          
          <div class="step">
            <h3>Set Up GB WhatsApp</h3>
            <p>Open the app, verify your phone number, and restore your chats if needed.</p>
          </div>
          
          <div class="step">
            <h3>Enjoy the Features</h3>
            <p>Explore privacy options, themes, auto-replies, and much more.</p>
          </div>
        </div>
        
        <div class="note">
          <p><strong>Note:</strong> Always download GB WhatsApp APK from trusted sources to ensure safety. Back up your chats before installation to avoid data loss.</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue'
import Breadcrumbs from '@/components/Breadcrumbs.vue'

export default {
  name: 'DownloadPage',
  components: {
    HeadNav,
    Breadcrumbs
  },
  head() {
    return {
      title: 'GBWhatsApp APK Information and Safety Notes',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Read GBWhatsApp APK version details, Android compatibility notes, and safety guidance. Direct APK distribution is currently unavailable on this site.'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'GB WhatsApp APK information, GB WhatsApp safety notes'
        }
      ]
    }
  }
}
</script>

<style scoped>
.download-page {
  min-height: 100vh;
  color: #333;
}

.container {
  width: 80%;
  margin: 0 auto;
  padding: 0 20px;
}

/* Header Section */
.hero-section {
  padding: 80px 0;
  text-align: center;
  background: rgba(255, 255, 255, 0.95);
  margin: 20px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.hero-section h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.hero-section p {
  font-size: 1.2rem;
  line-height: 1.6;
  color: #555;
  margin-bottom: 30px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

/* App Details Section */
.app-details-section {
  padding: 60px 0;
  background: rgba(255, 255, 255, 0.95);
  margin: 20px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.app-details-section h2 {
  font-size: 2.2rem;
  font-weight: 700;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 40px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.details-table {
  overflow-x: auto;
}

.details-table table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.details-table td {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  font-size: 1.1rem;
}

.details-table tr:first-child td {
  background: #f8f9fa;
  font-weight: 700;
  color: #2c3e50;
}

.details-table tr:not(:first-child) td:first-child {
  background: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
}

/* Guide Sections */
.download-guide-section,
.installation-guide-section {
  padding: 60px 0;
  background: rgba(255, 255, 255, 0.95);
  margin: 20px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.download-guide-section h2,
.installation-guide-section h2 {
  font-size: 2.2rem;
  font-weight: 700;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.download-guide-section p,
.installation-guide-section p {
  font-size: 1.1rem;
  text-align: center;
  color: #555;
  margin-bottom: 40px;
}

.guide-steps {
  display: grid;
  gap: 30px;
  max-width: 800px;
  margin: 0 auto;
}

.step {
  background: white;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #25D366;
}

.step h3 {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 15px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}

.step p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #555;
  text-align: left;
  margin: 0;
}

.note {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 10px;
  padding: 20px;
  margin-top: 30px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.note p {
  color: #856404;
  font-weight: 500;
  margin: 0;
  text-align: left;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-section h1 {
    font-size: 2rem;
  }
  
  .hero-section p {
    font-size: 1.1rem;
  }
  
  .app-details-section h2,
  .download-guide-section h2,
  .installation-guide-section h2 {
    font-size: 1.8rem;
  }
  
  .step h3 {
    font-size: 1.2rem;
  }
  
  .step p {
    font-size: 1rem;
  }
  
  .container {
    padding: 0 15px;
  }
  
  .hero-section,
  .app-details-section,
  .download-guide-section,
  .installation-guide-section {
    margin: 10px;
  }
}
</style>
